import $ from 'jquery';
import debug from "debug";

const log = debug("cart-notification");

class CartNotification {
	constructor(element, options) {
		this.element = element;
		this.options = options;
		this.cartCountElement = element.querySelector(this.options.cartCountElementSelector);
		this.isOpened = false;

		log(this);
		this.watch();
	}

	watch() {
		this.element.addEventListener("updateCart", this.onUpdate.bind(this));
		this.element.addEventListener("transitionend", this.transitionHandler.bind(this));

		document.addEventListener(
			"click",
			this.documentClickHandler.bind(this)
		);
	}

	onUpdate(event) {
		this.updateCartCount(event.detail.count);
		if(!this.isOpened) {
			this.preFadeIn();
		}
	}

	updateCartCount(count) {
		const itemPluralised = count === 1
			? "item"
			: "items";
		this.cartCountElement.textContent = `${count} ${itemPluralised}`;
	}

	nextAnimationFrame(func) {
		window.requestAnimationFrame(()=>{
			window.requestAnimationFrame(func);
		});
	}

	preFadeIn() {
		this.isOpened = true;
		this.element.hidden = false;
		this.element.classList.add(this.options.transparentClass);

		// Cancel any pre-existing timer
		window.clearTimeout(this.closeTimer);

		this.closeTimer = setTimeout(function (callback) {
			callback();
		}, this.options.openDuration, this.fadeOut.bind(this));

		this.nextAnimationFrame(this.fadeIn.bind(this));
	}

	fadeIn() {
		this.element.classList.add(this.options.fadeInClass);
	}

	fadeOut() {
		this.isOpened = false;
		this.element.classList.add(this.options.transparentClass);
	}

	hide() {
		this.isOpened = false;
		this.element.hidden = true;
		this.element.classList.remove(this.options.transparentClass);

		document.removeEventListener(
			"click",
			this.documentClickHandler.bind(this)
		);
	}

	transitionHandler(event) {
		const element = this.element;

		if (event.target !== element) {
			return false;
		}

		if(this.isOpened) {
			log('opened');
			this.element.classList.remove(this.options.transparentClass);
			this.element.classList.remove(this.options.fadeInClass);
		} else {
			log('closed');
			this.hide();

		}
	}

	documentClickHandler(event) {
		this.hide();
	}

}

CartNotification.DEFAULTS = {
	transparentClass: "cart-notification--transparent",
	fadeInClass: "cart-notification--fade-in",
	cartCountElementSelector: "[data-items-in-cart]",
	openDuration: 6000
};

export default CartNotification;



// WEBPACK FOOTER //
// ./client/src/core/components/cart-notification/cart-notification.js